// expose a proxy for the tooltip namespace, so we can still access it if jQuery.ui overwrites it.
jQuery.fn.bootstrapTooltip = jQuery.fn.tooltip;
